module.exports = __webpack_public_path__ + "img/02.46f105e2.jpg";